import {useMutation} from "@tanstack/react-query";
import {deleteGroup} from "../services/GroupService";

export function useGroupDelete() {
    return useMutation({
        mutationFn: (id) => deleteGroup(id),
    });
}
